import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { PackageStatus } from 'src/app/core/enumerations/package-status';
import { AccountDto, LinkedAccountDto } from 'src/app/core/interfaces/linked-account-result';
import { BusinessUnitDto } from 'src/app/core/interfaces/loggedInUserDto';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { ResultsService } from 'src/app/feature/results/Service/results.service';

import { Constants } from '../constants';
import { ResultMessages } from '../error-messages';
import { LoaderService } from '../loader/loader.service';
import { BroadcastService } from '../services/broadcast.service';
import { NotificationService } from '../services/notification-service';
import { PageTitleService } from '../services/page-title.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';

@Component({
    selector: 'app-bu-la-select',
    templateUrl: './bu-la-select.component.html',
    styleUrls: ['./bu-la-select.component.scss'],
    standalone: false
})
export class BuLaSelectComponent implements OnInit, OnDestroy {
  public selectedLAs = new UntypedFormControl([]);
  public selectedBU: any;
  public oldBU: string;
  public isAllSelected = false;
  BUList = new Array<BusinessUnitDto>();
  public selectedText = 'selected';
  public BuLabelName = 'Select BU';
  public accountForPatient = new Array<number>();
  public enabledAccountCodes = new Array<string>();
  public selectedLA = new Array<LinkedAccountDto>();
  public accountCodesForSelectedBU = new Array<string>();
  accountList = new Array<LinkedAccountDto>();
  accountListSubject: Subject<any> = new Subject();
  selectedAccounts = [];
  selectedAccountsSubject: Subject<any> = new Subject();
  isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public options: {
      data: any;
    },
    public dialogRef: MatDialogRef<BuLaSelectComponent>,
    public componentPageTitle: PageTitleService,
    private resultService: ResultsService,
    private auth: AuthenticationService,
    private broadcastService: BroadcastService,
    private notification: NotificationService,
    private loader: LoaderService,
    public localStorageService: LocalStorageService,
  ) { }

  ngOnInit() {
    this.BUList = this.auth.GetLoggedInUserDetails().businessUnits;
    if (this.options) {
        this.selectedBU = this.options as any;
        this.loadBULinkedAccounts();
      }
    if (this.BUList.length === 1) {
      this.selectedBU = this.BUList[0].buCode;
      if (this.isValidSelectedBu()) {
      this.localStorageService.setItem(Constants.ManagePackageSelectedBu, this.selectedBU);
      }
      this.loadBULinkedAccounts();
    }
    document.querySelector('.mat-drawer-content').classList.add('zindex-auto');
    document.querySelector('#appNavbar').classList.add('highlight-navbar');
  }

  checkAccountListSize() {
    return this.selectedAccounts.length > 0;
  }

  loadBULinkedAccounts() {
    this.getLinkedAccountByBUCode(this.selectedBU);   
    this.BuLabelName = 'BU';
  }

  onAccountSelectionChange(selectedAccounts?) {
    // Auto-trigger when accounts are selected
    if (selectedAccounts && selectedAccounts.length > 0) {
      this.addAccountFilter(selectedAccounts);
    }
  }

  addAccountFilter(selectedAccounts?) {
    this.selectedAccounts = selectedAccounts.map(
      (la) => `${la.linkedAccountName} (${la.accountCode})`
    );
    this.broadcastService.broadcast(Constants.GET_LA_SELECTION_CHIP_IN_DIALOG, this.selectedAccounts);
    this.broadcastService.broadcast(Constants.ADD_ACCOUNT_CHIP, this.selectedAccounts);
    this.broadcastService.broadcast('SET_SELECTED_ACCOUNT', selectedAccounts);
    this.broadcastService.broadcast('setAccounts');
    this.broadcastService.broadcast(Constants.GET_LA_SELECTION_IN_DIALOG, {
      selectedAccounts: this.selectedAccounts,
      selectedAccountsDetails: selectedAccounts,
      accountList: this.accountList
    });
    this.accountListSubject.next(this.accountList);
    this.selectedAccountsSubject.next(this.selectedAccounts);
    this.close();
  }

 getLinkedAccountByBUCode(buCode: string) {
    this.loader.show();
    this.resultService.getLinkedAccountsAsPerBU(buCode).subscribe({
      next: (result) => {
        this.loader.hide();
        this.accountList = this.mapLinkedAccounts(result);
        this.accountListSubject.next(this.accountList);
        this.broadcastService.broadcast(
          Constants.GET_BU_SELECTION_IN_DIALOG,
           { selectedBU: this.selectedBU, BUList: this.BUList });

        if(this.componentPageTitle.title === Constants.RESULTS) {
        this.accountCodesForSelectedBU = new Array<string>();
        this.accountList.forEach(element => {this.accountCodesForSelectedBU.push(element.accountCode);});  
        localStorage.setItem(Constants.ACCOUNTCODE_FOR_SELECTEDBU,JSON.stringify(this.accountCodesForSelectedBU));
        }
        this.broadcastService.broadcast(
          Constants.FETCHED_LINKED_ACCOUNT,
          result
        );
      },
      error: (error) => {
        this.loader.hide();
        this.notification.warn(ResultMessages.LINKED_ACCOUNT_FETCH_ISSUE);
      }
    }
    );
  }

  addAccountFilterChip() {
    if (this.componentPageTitle.title === Constants.COMMERCIALORDER) {
      localStorage.setItem('orderSelectedBU', JSON.stringify(this.selectedBU));
      localStorage.setItem('orderSelectedAccount', JSON.stringify(this.selectedAccounts));
    }
    if (this.componentPageTitle.title === Constants.RESULTS) {
      localStorage.setItem('resultSelectedBU', JSON.stringify(this.selectedBU));
      localStorage.setItem(Constants.RESULT_SELECTED_ACCOUNT, JSON.stringify(this.selectedAccounts));
    }
    if (this.componentPageTitle.title === Constants.PACKAGE_LIST) {
      if (this.isValidSelectedBu) {
      localStorage.setItem(Constants.ManagePackageSelectedBu, JSON.stringify(this.selectedBU));
      }
      localStorage.setItem(Constants.ManagePackageSelectedAccounts, JSON.stringify(this.selectedAccounts));
    }
  }

  private mapLinkedAccounts(res) {
    return res as LinkedAccountDto[];
  }

  disabilityCheck() {
    return this.selectedAccounts.length === 0 || !this.selectedBU || this.selectedBU === null || this.selectedBU === '';
  }

  close() {
    this.dialogRef.close(false);
    this.cleanupDomClasses();
  }

  ngOnDestroy() {
    this.cleanupDomClasses();
  }

  private cleanupDomClasses() {
    document.querySelector('.mat-drawer-content')?.classList.remove('zindex-auto');
    document.querySelector('#appNavbar')?.classList.remove('highlight-navbar');
  }
  
  isValidSelectedBu() {
    return this.selectedBU && this.selectedBU !== 'null';
  }
}
